import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const MENU_FIXER_AGENT_ROUTES = new Set(['menuFixerAgent'])

export const checkMenuFixerAgentFeatureFlag: HermesGuardFn = async (to) => {
  if (!MENU_FIXER_AGENT_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.menuFixerAgent')) {
    return {
      name: 'brand.home',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
